import type { Option } from '@branchjs/neo-components';
import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIos = new ReduxAsyncAction<'UPDATE_IOS', string | Option | undefined, { ios: string | Option | undefined }>(
  'UPDATE_IOS'
);

UpdateIos.registerRequest(async (ios: string | Option | undefined) => {
  return { ios };
});

export const UPDATE_IOS = UpdateIos.actionNamespaceConstants;
export const updateIos = UpdateIos.request;

export type UpdateIosResponseAction = Action<typeof UPDATE_IOS.response> & {
  data: { ios: string | Option };
};
